module.exports = __webpack_public_path__ + "59cb2b50d90b060e16a3ec4fe2178a65.png";